import { makeRequest, makeJsonApiRequest } from '../base/axios.ts'
import { each } from 'lodash'

export default {
  fetchPhoto: function (id, apiVersion = 1) {
    const commonRequestParams = {
      requestId: `fetch-photo-${id}`,
    }
    switch (apiVersion) {
      case 1:
        return makeRequest({
          ...commonRequestParams,
          url: `/api/v1/photos/${id}`,
        })
      case 2:
        return makeJsonApiRequest({
          ...commonRequestParams,
          url: `/api/v2/photos/${id}`,
        })
      default:
        return Promise.reject(new Error('Invalid API version'))
    }
  },

  createPhotos: function (files, { maxItems, apiVersion }) {
    maxItems = maxItems || 10
    apiVersion = apiVersion || 1

    if (files.length === 0) {
      return Promise.reject(new Error('No files to upload'))
    }

    const data = new FormData()
    each(files, (file, i) => {
      if (i < maxItems) {
        // Note: Don't use Array.slice files here, can be a FileList or Array
        data.append('photos[][image]', file, file.name)
      }
    })

    const commonRequestParams = {
      url: '/api/v1/photos',
      method: 'post',
      data,
      requestId: 'upload-photo',
      headers: {
        'Content-Type': 'multipart/form-data', // Override default Content-Type
      },
    }

    switch (apiVersion) {
      case 1:
        return makeRequest({
          ...commonRequestParams,
          url: '/api/v1/photos',
        })

      case 2:
        return makeJsonApiRequest({
          ...commonRequestParams,
          url: '/api/v2/photos',
        })
      default:
        return Promise.reject(new Error('Invalid API version'))
    }
  },

  deletePhoto: function (id, apiVersion = 1) {
    const commonRequestParams = {
      method: 'delete',
      requestId: `delete-photo-${id}`,
    }
    switch (apiVersion) {
      case 1:
        return makeRequest({
          ...commonRequestParams,
          url: `/api/v1/photos/${id}`,
        })

      case 2:
        return makeJsonApiRequest({
          ...commonRequestParams,
          url: `/api/v2/photos/${id}`,
        })

      default:
        return Promise.reject(new Error('Invalid API version'))
    }
  },

  fetchUserPhotos: function (pageNumber, apiVersion = 1) {
    const commonRequestParams = {
      requestId: `get-photo-page-${pageNumber}`,
    }
    switch (apiVersion) {
      case 1:
        return makeRequest({
          ...commonRequestParams,
          url: `/api/v1/photos?page=${pageNumber}`,
        })

      case 2:
        return makeJsonApiRequest({
          ...commonRequestParams,
          url: `/api/v2/photos?page=${pageNumber}`,
        })

      default:
        return Promise.reject(new Error('Invalid API version'))
    }
  },
}
